import { clsx } from 'clsx'
import { useId, type InputHTMLAttributes, type ReactNode, type Ref } from 'react'

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  hint?: ReactNode
  error?: string | null
  ref?: Ref<HTMLInputElement>
}

export function Field({ label, hint, error, className, id, ref, ...rest }: FieldProps) {
  const auto = useId()
  const inputId = id ?? auto
  const describedBy = error ? `${inputId}-error` : hint ? `${inputId}-hint` : undefined
  return (
    <div className={className}>
      <label htmlFor={inputId} className="field-label">
        {label}
      </label>
      <input
        ref={ref}
        id={inputId}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        className={clsx('input', error && 'border-danger hover:border-danger')}
        {...rest}
      />
      {error ? (
        <p id={`${inputId}-error`} className="mt-1.5 text-[13px] text-danger">
          {error}
        </p>
      ) : (
        hint && (
          <p id={`${inputId}-hint`} className="mt-1.5 text-[13px] text-faint">
            {hint}
          </p>
        )
      )}
    </div>
  )
}
